import {
  Box,
  RadioGroup,
  Radio as MuiRadio,
  Grid,
  Stack,
  FormControlLabel,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { SSText } from "src/components/base/components/SSText";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";

const Reasons = ({ name = "reason", required = false }) => {
  const { md: mdUp } = useCssMediaQuery("up");
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  return (
    <Box>
      <RadioGroup name={name} onChange={(e) => setValue(name, e.target.value)}>
        <Stack direction={mdUp ? "row" : "column"}>
          <Stack width={"100%"}>
            <FormControlLabel
              value="price"
              control={<MuiRadio {...register(name, { required })} />}
              label="Price"
            />
            <FormControlLabel
              value="schedule"
              control={<MuiRadio {...register(name, { required })} />}
              label="Schedule of Games"
            />
            <FormControlLabel
              value="seat"
              control={<MuiRadio {...register(name, { required })} />}
              label="Seat Location"
            />
          </Stack>

          <Stack width={"100%"}>
            <FormControlLabel
              value="team"
              control={<MuiRadio {...register(name, { required })} />}
              label="Team Performance"
            />
            <FormControlLabel
              value="other"
              control={<MuiRadio {...register(name, { required })} />}
              label="Other"
            />
          </Stack>
        </Stack>
      </RadioGroup>
      {errors[name]?.type === "required" && (
        <SSText color="error.main">This field is required</SSText>
      )}
    </Box>
  );
};

export default Reasons;
